import * as React from "react";
import { Button, ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { packages } from "../helpers/enums";

export default function SetPackage({
  buttonVariant = "outlined",
  buttonBgColor = "#ffffff",
  assessment,
  selectedAssessmentChange,
}) {
  return (
    <ButtonGroup variant="outlined" sx={{ mx: 2 }}>
      <Button
        variant={buttonVariant}
        sx={{
          borderRadius: 20,
          height: 23,
          textTransform: "none",
        }}
        onClick={() => {
          assessment.package = packages.BASIC;
          selectedAssessmentChange(assessment);
        }}
      >
        Basic
      </Button>
      <Button
        sx={{
          borderRadius: 20,
          height: 23,
          textTransform: "none",
          borderColor: "black",
          color: "black",
          bgcolor: buttonBgColor,
        }}
        onClick={() => {
          assessment.package = packages.PREMIUM;
          selectedAssessmentChange(assessment);
        }}
      >
        Premium
      </Button>
    </ButtonGroup>
  );
}
